import {fontSizes as libFontSizes} from '@recipe-ui/legacy-theme';
import merge from 'lodash/merge';

const fontSizes = merge(libFontSizes, {
  xsmall: '0.75rem',
  small: '0.85rem',
  normal: '1rem',
  medium: '1.25rem',
  large: '1.75rem',
  xlarge: '2rem',
});

const fontFamily = `"Figtree Variable", Figtree, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`;
const lineHeight = '1.15';
const uppercaseText = `
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export {fontSizes, fontFamily, lineHeight, uppercaseText};
